export default {
  regionalRiskAssessment: {
    eudrDueDiligence: "Diligência Devida EUDR",
    title: "Avaliação Regional de Risco",
    titleTT: "Referência de países na avaliação de risco regional do EUDR",
    details: "Detalhes",
    detailsTT: "Expanda para visualizar os critérios detalhados e as referências relacionadas à classificação de alto risco, com foco no desmatamento, direitos indígenas, corrupção e questões de direitos humanos.",
    createNewCountryReport: "Criar Novo Relatório de País",
    updateCountryReport: "Atualizar Relatório de País",
    duplicateCountryReport: "Duplicar Relatório de País",
    search: "Pesquisar",
    country: "País",
    dateCreated: "Data de Criação",
    edit: "Editar",
    delete: "Excluir",
    duplicate: "Duplicar",
    actions: "Ações",
    submit: "Enviar",
    save: "Salvar",
    cancel: "Cancelar",
    selectCountry: "Selecionar País",
    riskAssessmentCriteria: "Critérios de Avaliação de Risco",
    riskLevel: "Nível de Risco",
    unassigned: "Não Atribuído",
    standard: "Padrão",
    standardToHigh: "Padrão para Alto",
    high: "Alto",
    reportDetails: "Detalhes do Relatório",
    select: "Selecionar",
    requiredFields: "Este campo é obrigatório",
    pleaseFillRequiredFields: "Por favor, preencha todos os campos obrigatórios",
    createCuccess: "Avaliação regional de risco criada com sucesso",
    updateSuccess: "Avaliação regional de risco atualizada com sucesso",
    createError: "Erro ao criar avaliação regional de risco",
    updateError: "Erro ao atualizar avaliação regional de risco",
    deleteSuccess: "Avaliação regional de risco excluída com sucesso",
    duplicateSuccess: "Avaliação regional de risco duplicada com sucesso",
    deleteRegionalRisk: "Excluir Avaliação Regional de Risco",
    confirmDelete: "Tem certeza de que deseja excluir esta avaliação regional de risco?",
    confirm: "Confirmar",
    saveSuccess: "Avaliação regional de risco salva com sucesso",
    fetchError: "Erro ao buscar avaliação regional de risco",
    disregard: "Ignorar Segmentos",
    addRegionalRiskAssessment: "Adicionar Avaliação de Risco Regional",
    summary: "Resumo",
    summaryTT: "Esta seção descreve os níveis de risco atribuídos com base em dados e referências abrangentes.",
    summaryText: "A avaliação de risco do país classificará o país da fazenda de acordo com os seguintes níveis de risco (Alto, Padrão e Zero/Négligível) com base em referências verificáveis, informações, documentos e dados. Resultados diferentes de 'Zero/Négligível' indicarão a necessidade de alguma ação de mitigação de risco (AMR) para garantir 'Risco Zero/Négligível'. A Tabela 1 mostra os resultados gerais da avaliação de risco para a (country). A avaliação completa do risco do país está anexada a este documento no Anexo III.",
    disregardConfirmTitle: "Ignorar Qualquer Segmento ou Todos",
    selectSegment: "Selecionar segmentos para ignorar.",
    addConfirmTitle: "Adicionar Qualquer Segmento ou Todos",
    deselectToAddSegment: "Deselecione os segmentos para adicionar.",
    all: "Todos",
    protectedAreas: "Áreas Protegidas e Indígenas",
    verificaton: "Verificação com o Banco de Dados do Governo do Brasil",
    confirmation: "Confirmação",
    confirmationMessage: "Tem certeza de que deseja ignorar a avaliação de risco regional? Confirmar esta ação resultará na remoção da avaliação de risco regional do relatório de due diligence.",
    noSegmentSelectedMessage: "Nenhum segmento foi selecionado. Por favor, selecione um segmento para prosseguir.",
    singleRiskAssessmentCriteriaMessage: "Tem certeza de que deseja adicionar ou remover os Critérios de Avaliação de Risco Regional? Confirmar esta ação atualizará o relatório de due diligence.",
    singleProtectedAreasMessage: "Tem certeza de que deseja adicionar ou remover as Áreas Protegidas e Indígenas? Confirmar esta ação atualizará o relatório de due diligence.",
    bothSegmentsMessage: "Tem certeza de que deseja adicionar ou remover tanto os Critérios de Avaliação de Risco Regional quanto as Áreas Protegidas e Indígenas? Confirmar esta ação atualizará o relatório de due diligence.",
    segmentsUpdatedSuccessfully: "Segmentos atualizados com sucesso"
  }
}
